import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAuth } from '@app/contexts/auth'
import { ROLES } from '@modules/types'

export const RootRedirectHandler = () => {
  const { permissions, permissionsLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (permissionsLoading || !permissions) {
      return
    }

    if (!Array.isArray(permissions)) {
      navigate('/login', { replace: true })
      return
    }

    const hasPublisherRole =
      permissions.includes(ROLES.ADMIN_PANEL_PUBLISHER) ||
      permissions.includes(ROLES.ADMIN_PANEL_COPYRIGHT_MANAGER)

    const hasSharedRequestRole = permissions.includes(ROLES.ADMIN_PANEL_SHARED_REQUEST_USER)

    if (hasPublisherRole) {
      navigate('/request', { replace: true })
    } else if (hasSharedRequestRole) {
      navigate('/share', { replace: true })
    } else {
      navigate('/login', { replace: true })
    }
  }, [permissions, permissionsLoading, navigate])

  return null
}
